// extracted by mini-css-extract-plugin
export default {"team":"Team_team__8dI4V","h3":"Team_h3__w3tQX","members":"Team_members__X0cy6"};